// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2QvtF","clinicsSelect":"TableHeading_clinicsSelect__1ORwU"};